var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: _vm.title } },
    [
      _c("v-divider"),
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2 mt-2",
          attrs: { width: "100%", elevation: "0", outlined: "" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" },
            [_vm._v("Common")]
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "4", sm: "4" } },
                [
                  _c("r-currency-kind-dropdown", {
                    attrs: {
                      model: _vm.value.currencyGear,
                      label: "Currency Gear",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.value, "currencyGear", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "4" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Multiplier",
                      rules: [_vm.validator.points],
                      hint: "Example: 1;3;5",
                    },
                    model: {
                      value: _vm.value.multipliersString,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "multipliersString",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.multipliersString",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-plinko-ball-config", {
        attrs: { model: _vm.value.ball },
        on: {
          "update:model": function ($event) {
            return _vm.$set(_vm.value, "ball", $event)
          },
        },
      }),
      _c("r-plinko-spring-config", {
        attrs: { model: _vm.value.spring },
        on: {
          "update:model": function ($event) {
            return _vm.$set(_vm.value, "spring", $event)
          },
        },
      }),
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2 mt-3",
          attrs: { width: "100%", elevation: "0", outlined: "" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" },
            [_vm._v("Stages")]
          ),
          _c(
            "v-row",
            { staticClass: "pt-4", attrs: { dense: "" } },
            [
              _c("r-plinko-stage-config-table", {
                ref: "table",
                attrs: { items: _vm.value.stages, title: "Stages" },
                on: {
                  "update:items": function ($event) {
                    return _vm.$set(_vm.value, "stages", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }